import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL } from "./legal/legalData";
import { Footer } from "../components/landing/Footer";

const Para = ({ text }) => {
  if (text.startsWith("Email:")) {
    const addr = text.replace("Email:", "").trim();
    return (
      <p className="mt-3 text-white/60">
        Email:{" "}
        <a href={`mailto:${addr}`} className="text-white underline underline-offset-4">
          {addr}
        </a>
      </p>
    );
  }
  return <p className="mt-3 leading-relaxed text-white/60">{text}</p>;
};

export default function LegalPage() {
  const { slug } = useParams();
  const doc = LEGAL[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!doc) {
    return (
      <div className="grain flex min-h-screen items-center justify-center bg-[#0a0a0c] text-white">
        <div className="text-center">
          <p className="text-white/60">Page not found.</p>
          <Link to="/" className="mt-4 inline-block text-white underline">
            Back home
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="grain min-h-screen bg-[#0a0a0c]" data-testid={`legal-${slug}`}>
      <div className="mx-auto max-w-3xl px-6 py-16 md:px-8 md:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-white/50 transition-colors hover:text-white"
          data-testid="legal-back"
        >
          <ArrowLeft className="h-4 w-4" /> Back to Radiate
        </Link>

        <p className="mt-12 text-xs font-semibold uppercase tracking-[0.35em] text-white/40">
          Legal
        </p>
        <h1 className="mt-4 font-display text-4xl font-thin tracking-tight text-white md:text-5xl">
          {doc.title}
        </h1>
        <p className="mt-3 text-sm text-white/45">{doc.subtitle}</p>

        <div className="mt-8">
          {doc.intro?.map((t, i) => (
            <Para key={i} text={t} />
          ))}
        </div>

        <div className="mt-4 space-y-10">
          {doc.sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-display text-xl font-normal tracking-tight text-white">
                {s.h}
              </h2>
              {s.body?.map((t, j) => (
                <Para key={j} text={t} />
              ))}
              {s.list && (
                <ul className="mt-4 space-y-2">
                  {s.list.map((li, j) => (
                    <li key={j} className="flex gap-3 text-white/60">
                      <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-[#ffb7b2]" />
                      <span className="leading-relaxed">{li}</span>
                    </li>
                  ))}
                </ul>
              )}
              {s.after?.map((t, j) => (
                <Para key={`a${j}`} text={t} />
              ))}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
